<template lang="html">
  <div class="wrapper flex">
    <div class="container">
      <div :class="['fade-in', showTitle ? 'visible' : 'hidden']">
        <h1>C.A.R.A:P.A.C.E. SPLInt</h1>
        <p class="small">Standard Pilot Logging Interface for<br>Combat And Reconnaissance Architecture: Pilot-Augmented Conflict Equipment</p>
      </div>
      <div v-if="newGame">
        <div :class="['notice-container fade-in', showNotice ? 'visible' : 'hidden']">
          <h3>⚠️ New pilot detected</h3>
          <p>Pilot will experience intermittent induced cryogenic hibernation for duration of LOCKDOWN Protocol.</p>
          <p>Pilot is expected to log equipment and personnel status between hibernation periods.</p>
          <p>Stand by for further progress reports.</p>
        </div>
        <div :class="['fade-in', showButton ? 'visible' : 'hidden']">
          <router-link to="/setup"><button>Initialise setup routine</button></router-link>
        </div>
      </div>
      <div v-else>
        <hr :class="['fade-in', showHr ? 'visible' : 'hidden']">
        <div :class="['fade-in', showWelcome ? 'visible' : 'hidden']">
          <h3 class="welcome">Welcome back, {{ pilotFormatted }}</h3>
          <p>{{ carapaceFormatted }}</p>
        </div>
        <div :class="['fade-in', showButton ? 'visible' : 'hidden']">
          <router-link to="/logs"><button>Log in</button></router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'welcome',
  data() {
    return {
      interval: 1200,
      showTitle: false,
      showNotice: false,
      showButton: false,
      showHr: false,
      showWelcome: false,
    }
  },
  computed: {
    ...mapState({
      newGame: state => state.gameSettings.newGame,
    }),
    ...mapGetters([
      'pilotFormatted',
      'carapaceFormatted',
    ]),
  },
  mounted() {
    setTimeout(() => {
      this.showTitle = true;
    }, this.interval);

    if (this.newGame) {
      setTimeout(() => {
        this.showNotice = true;
      }, this.interval * 2);

      setTimeout(() => {
        this.showButton = true;
      }, this.interval * 3);
    } else {
      setTimeout(() => {
        this.showHr = true;
      }, this.interval * 2);

      setTimeout(() => {
        this.showWelcome = true;
      }, this.interval * 3);

      setTimeout(() => {
        this.showButton = true;
      }, this.interval * 4);
    }
  },
}
</script>

<style lang="css" scoped>
.flex {
  display: flex;
  height: calc(100% - 100px);
  width: calc(100% - 100px);
  position: absolute;
}

.container {
  margin: auto 0;
  text-align: center;
  width: 100%;
}

button {
  margin: 50px auto 0 auto;
}

.small {
  font-size: 13px;
  margin-bottom: 50px;
}

.welcome {
  margin-top: 50px;
}

.notice-container {
  border: 1px solid var(--primary-color);
  border-radius: 5px;
  text-align: left;
  padding: 10px 30px;
}
</style>
